import { Skeleton } from '@/components/ui/skeleton'

interface SkeletonListProps {
  items?: number
  hasAvatar?: boolean
  hasMeta?: boolean
}

export const SkeletonList = ({
  items = 5,
  hasAvatar = false,
  hasMeta = false,
}: SkeletonListProps) => {
  return (
    <div className="space-y-4" role="status" aria-label="Loading list">
      {Array.from({ length: items }).map((_, index) => (
        <div key={index} className="flex items-center gap-4">
          {hasAvatar && (
            <Skeleton className="h-10 w-10 rounded-full shrink-0" />
          )}
          <div className="flex-1 min-w-0">
            <Skeleton className="h-4 w-3/4" />
            {hasMeta && (
              <Skeleton className="h-3 w-1/2 mt-2" />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
